/** FLICKR */
export const FLICKR_USER_ID = '24033063@N00';

export enum SizeKeys {
    small = '_n',
    original = '_o',
    medium500 = '_m',
    medium800 = '_c',
    large = '_l'
}

export type PageType = 'gatza' | 'araotz' | 'bestaldetik' | 'home';